import { HttpClient } from "@angular/common/http";
import { Injectable, inject, signal } from "@angular/core";
import { MessageService } from "primeng/api";
import { catchError, combineLatest, map, Observable, of } from "rxjs";
import { InviteType } from "src/app/dashboard/models/invite";
import { ConfigService } from "src/app/shared/services/config-service";
import { SystemState, SystemStateModel, SystemType } from "../models/system-state.model";

@Injectable({
  providedIn: 'root'
})
export class SystemStateService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private messageService = inject(MessageService);

  /**
   * Liefert die Basis-URL der API, abhängig vom InviteType.
   * @param type - Der Typ der Einladung (NectaOne oder VendorCatalog)
   * @returns URL als string
   */
  private getApiUrl(type: InviteType): string {
    return this.configService.getUrlNectaOneApi()
  }

  /**
   * Holt Einladungen von beiden APIs (NectaOne und VendorCatalog) und ordnet den jeweiligen InviteType zu.
   * Bei Fehlern wird ein Fehler-Toast angezeigt und ein leerer Array zurückgegeben..
   * @returns Observable mit einer kombinierten Liste von Einladungen.
   */
  public fetchSystemState(): Observable<SystemStateModel[]> {

        /*const nectaOneSystemState$ = this.http.get<SystemStateModel>(`${this.configService.getUrlNectaOneApi()}/syste-state`).pipe(
          map(systemState => systemState),
          catchError(error => {
           this.handleError<SystemStateModel>('Fehler beim Abrufen des NectaOne-Systemstatus', error, { state: SystemState.UNKNOWN });
        return of({ state: SystemState.OFFLINE });
          })
        );
    
        const vendorCatalogSystemState$ = this.http.get<SystemStateModel>(`${this.configService.getUrlVendorCatalogApi()}/syste-state`).pipe(
          map(systemState => systemState),
          catchError(error => {
            this.handleError<SystemStateModel>('Fehler beim Abrufen des VendorCatalog-Systemstatus', error, { state: SystemState.UNKNOWN });
            return of({ state: SystemState.OFFLINE });
          })
        );*/

        const nectaOneSystemState$ = of<SystemStateModel>({ systemType: SystemType.NECTA_ONE, state: SystemState.ONLINE });
        const vendorCatalogSystemState$ = of<SystemStateModel>({ systemType: SystemType.VENDOR_CATALOG, state: SystemState.ONLINE });

        // Kombiniert beide Observables und führt die Listen zusammen.
        return combineLatest([nectaOneSystemState$, vendorCatalogSystemState$]).pipe(
          map(([nectaOne, vendorCatalog]) => [nectaOne, vendorCatalog])
        );
    
  }


      /**
   * Zentralisierte Fehlerbehandlung.
   * Loggt den Fehler in der Konsole, zeigt einen Toast an und gibt einen Standardwert zurück.
   * @param message - Benutzerdefinierte Fehlermeldung
   * @param error - Der aufgetretene Fehler
   * @param result - Standardrückgabewert im Fehlerfall
   * @returns Observable mit dem Standardwert.
   */
  private handleError<T>(message: string, error: any, result?: T): Observable<T> {
    console.error(message, error);
    this.messageService.add({ severity: 'error', summary: 'Fehler', detail: message });
    return of(result as T);
  }
}